class CRSearchResults {
  constructor() {
    this.segments = {}
  }
  addSegment(title, cardname) {
    this.segments.push({
      title: title,
      cardname: cardname,
      page: 0,
      pages: 0
    })
  }
  separate_results(query) {
    document.querySelectorAll(`${query} [data-item-type]`).forEach((result) => {
      result.setAttribute('hidden', '')
      result.parentNode.removeChild(result)
      document
        .querySelector(`[data-segment="${result.getAttribute('data-item-type')}"]`)
        .querySelector('.search-results')
        .appendChild(result)
    })
    // define segments
    document.querySelectorAll('.collection-card[data-segment]').forEach((segment) => {
      let results = segment.querySelectorAll('[data-item-type]')
      let perpage = parseInt(segment.getAttribute('data-perpage'))
      let pages = (results.length - (results.length % perpage)) / perpage
      if (results.length % perpage > 0) {
        pages++
      }
      results.forEach((result, index) => {
        result.setAttribute('data-index', index)
        if (index < perpage) {
          result.removeAttribute('hidden')
          result.classList.add('active')
        }
      })
      this.segments[segment.getAttribute('data-segment')] = {
        perpage: perpage,
        pages: pages,
        page: 0,
        resultcount: results.length
      }
      document.title = `Search: ${Object.values(this.segments).reduce((a, b) => a + b.resultcount, 0)} results`
      try {
        document.querySelector(`.result-count-${segment.getAttribute('data-segment')}`).innerHTML = results.length
      } catch (e) {
        console.error(e)
      }
      this.paginate(segment.getAttribute('data-segment'))
      if (results.length < 1) {
        segment.setAttribute('hidden', '')
      }
    })
    document.querySelectorAll('li.pagelink').forEach((pg) => {
      pg.addEventListener('click', (event) => {
        this.go(pg.getAttribute('data-segment'), parseInt(pg.getAttribute('data-index')))
      })
    })
    document.querySelectorAll('li.prevpage').forEach((pg) => {
      pg.addEventListener('click', (event) => this.prevpage(pg.getAttribute('data-segment')))
    })
    document.querySelectorAll('li.nextpage').forEach((pg) => {
      pg.addEventListener('click', (event) => this.nextpage(pg.getAttribute('data-segment')))
    })
  }
  paginate(segname) {
    let pagelinks = []
    let segment = this.segments[segname]
    let page = 0
    if (segment.pages < 2) {
      document.querySelector(`.collection-card[data-segment="${segname}"]`).querySelector('.search-pagination').innerHTML = ''
      return
    }
    for (let page = 0; page < segment.pages; page++) {
      let al = ''
      if (page == 0) {
        al = 'active'
      }
      pagelinks.push(`<li class="pagelink ${al}" data-segment="${segname}" data-index="${page}"><span>${page + 1}</span></li>`)
    }
    document.querySelector(`.collection-card[data-segment="${segname}"]`).querySelector('.search-pagination').innerHTML = `
         <ul class="pagination-custom"><li class="prevpage disabled" data-segment="${segname}"><span>&lt;</span></li>
         ${pagelinks.join('')}
         <li class="nextpage" data-segment="${segname}"><span>&gt;</span></li>
         </ul>
      `
  }
  go(segname, index) {
    let segment = document.querySelector(`.collection-card[data-segment="${segname}"]`)
    segment.querySelector(`.pagelink.active`).classList.remove('active')
    segment.querySelector(`.pagelink[data-index="${index}"]`).classList.add('active')
    if (segment) {
      segment.querySelectorAll('.search-results .active').forEach((result) => {
        result.setAttribute('hidden', '')
        result.classList.remove('active')
      })
      for (let i = 0; i < this.segments[segname].perpage; i++) {
        let offset = index * this.segments[segname].perpage + i

        let result = segment.querySelector(`.search-results [data-index="${offset}"]`)

        if (result) {
          result.removeAttribute('hidden')
          result.classList.add('active')
        }
      }
    }
    if (index > 0) {
      document.querySelector(`.prevpage[data-segment="${segname}"]`).classList.remove('disabled')
    } else {
      document.querySelector(`.prevpage[data-segment="${segname}"]`).classList.add('disabled')
    }
    if (index >= this.segments[segname].pages - 1) {
      document.querySelector(`.nextpage[data-segment="${segname}"]`).classList.add('disabled')
    } else {
      document.querySelector(`.nextpage[data-segment="${segname}"]`).classList.remove('disabled')
    }
    segment.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
    this.segments[segname].page = index
    document.dispatchEvent(new Event('search-page-click'))
  }
  prevpage(segname) {
    if (this.segments[segname].page > 0) {
      this.go(segname, this.segments[segname].page - 1)
      document.dispatchEvent(new Event('search-page-click'))
    }
  }
  nextpage(segname) {
    if (this.segments[segname].page < this.segments[segname].pages - 1) {
      this.go(segname, this.segments[segname].page + 1)
      document.dispatchEvent(new Event('search-page-click'))
    }
  }
}
